import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
} from "../services/types/ComponentTypes";

export const screen_169_users_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Users",
        style: {},
        fabAction: {
            type: "add",
            screenId: "42",
            action: "modulev1/users_add",
        },
        childComponents: [
            {
                componentType: ComponentType.SUMMARY_LIST,
                Name: "user_summary",
                BindValue: "grid_emp",
                titleValue: "Users",
                SummeryActions: [
                    {
                        Action: {
                            Action: "Navigate",
                            Navigate: "modulev1/users_add/<id>",
                        },
                        ActionType: "Edit",
                        ScreenId: "42",
                    },
                    {
                        Action: {
                            Action: "Delete",
                            Module: "user_summary",
                        },
                        ActionType: "Delete",
                        ScreenId: "42",
                    },
                ],
                Form: {
                    Name: "user_summary",
                    TableName: "users",
                    DisplayName: "Users",
                    Fields: [
                        {
                            IncludeLabel: true,
                            Label: "id",
                            BindValue: "id",
                            Json_Attribute: "id",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: false,
                            IsPrimary: true,
                        },
                        {
                            IncludeLabel: true,
                            Label: "User name",
                            BindValue: "name",
                            Json_Attribute: "username",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                            IsPrimary: false,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Mobile",
                            BindValue: "txt_mobile",
                            Json_Attribute: "mobile_no",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                            IsPrimary: false,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Group",
                            IsMandatory: true,
                            BindValue: "drp_group",
                            Json_Attribute: "role_id",
                            componentType: ComponentType.SEARCHABLE_DROPDOWN,
                            showInSummary: true,
                            LookupName: "user_group",
                        },
                    ],
                },
            },
        ],
    },
];